/* eslint-disable prettier/prettier */
import React from 'react';
import StandingsRow from "../../Standings/StandingsRow";
import {useStandings} from "../../../hooks/standings";
import {useTeamLogos} from "../../../hooks/team";
import {filterStandings} from "../../../utils/functionalUtils";
// use this when new api is fixed
// Object.entries(standings).map(([key, value]) => {
//     consol.log(value);
// });
function StandingsTable( {season, data, dataLoading}) {
    const [teamLogos, loadingTeamLogos] = useTeamLogos();
    if (!data || !teamLogos || dataLoading || loadingTeamLogos) return null;
    const standings = filterStandings(data);
    const getTeamLogo = (abbrv) => {
        const team = teamLogos?.find((x) => x.abbrv === abbrv);

        return (
            team?.logo ||
            team?.logoImageUrl ||
            '/wp-content/themes/sef-leagues/images/generic-team.png'
        );
    };
    return standings?.map((item) => (
        <StandingsRow
            data={item}
            key={item.id}
            logo={getTeamLogo(item.teamAbbrv)}
        />
    ));
}
export default StandingsTable;